// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"2243489d","324":"5230bb0c","746":"75e8e453","858":"6ed54851","891":"b0d8f582"}[chunkId] + ".chunk.js";
};